export default "__VITE_ASSET__wHI0FGsH__"